import { render, staticRenderFns } from "./UpdateNewCrmTask.vue?vue&type=template&id=66bd7db5"
import script from "./UpdateNewCrmTask.vue?vue&type=script&lang=js"
export * from "./UpdateNewCrmTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports